import { ConfigProps } from './Props';
import { VegaCard, VegaDivider, VegaFlex, VegaFont, VegaGrid } from '@globalpayments/vega-react';
import { useNavigate, createSearchParams } from 'react-router';

interface Props {
  configs: ConfigProps[];
}

const Config: React.FC<Props> = ({ configs }) => {
  const navigate = useNavigate();

  const onClick = (cid: number) => {
    navigate({
      pathname: '/configinfo',
      search: `?${createSearchParams({ id: cid.toString() })}`,
    });
  };

  return (
    <VegaGrid column={{ default: 1, M: 2, XL: 3 }} gap="size-32">
      {configs.map((config) => (
        <VegaCard key={config.id} onClick={() => onClick(config.id)} padding="size-24" variant="border">
          <VegaFlex direction="col" gap="size-8">
            <VegaFont as="h2" variant="font-h5">{config.configName}</VegaFont>
            <VegaDivider />
            <VegaFont as="p" variant="font-p1-short">{config.channel}</VegaFont>
            <VegaFont as="p" variant="font-p1-short">{config.subChannel}</VegaFont>
          </VegaFlex>
        </VegaCard>
      ))}
    </VegaGrid>
  );
};

export default Config;
